module.exports = __webpack_public_path__ + "assets/img/borino-carbon.8acd2a4a.png";